export enum OrderStatusEsEnum {
    REVIEW_APPOINTMENT = "Review Appointment",
    REVIEW_EXECUTION = "Review Execution",
    BUDGET_VALIDATION = "Budget Validation",
    CLOSING_REQUEST = "Closing Request",
    REJECTED = "Rejected",
    COMPLETED = "Completed",
    LICENSE_MANAGEMENT = "License Management",
    INSTALLATION_APPOINTMENT = "Installation Appointment",
    INSTALLATION_EXECUTION = "Installation Execution",
    LEGALIZATION = "Legalization",
    CANCELED = "Canceled",
    REVIEWING = "Reviewing",
}
